import { useEffect } from 'react';
import { Auth } from 'firebase/auth';
import { useAuth } from '../../auth';

/**
 * Hook that can be used to get the current authentification object.
 * @returns the current authentification object
 */
export function useAuthManager(firebaseAuth: Auth) {
    const onAuthStateChanged = useAuth((state) => state.onAuthStateChanged);
    useEffect(() => {
        onAuthStateChanged(firebaseAuth);
    }, []);
}
